import React from 'react'

const VideoPlayer = (props) => {
  return (
    <>
        <video className={props.class} muted loop autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
            <source src={process.env.PUBLIC_URL + props.videosource} type="video/mp4"/>
        </video>
      
    </>
  )
}

export default VideoPlayer
